<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('repack.create')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Lookup Batch Label"
                                @scanned="scanned_batches.length > 0 ? setFromScan($event) : getPending($event)"
                                @closed="(scanned_batches = []), (scanned_qty = [])"
                                @remove="removeFromSelected($event)"
                                :show-default-slot="scanned_batches.length > 0"
                                scan-label="i"
                                :global="true"
                                :snackbar="false"
                            >
                                <template slot="button">
                                    <v-btn @mouseup.left="setInitialSchedule()" :disabled="scanned_batches.length == 0" color="success">
                                        {{ $t("lang.continue") }}
                                    </v-btn>
                                </template>
                                <template slot-scope="props" v-if="scanned_batches.length > 0">
                                    <div>
                                        <span class="fs-30">{{ scanned_batches[0].name }}</span
                                        ><br />
                                        <span class="fs-22">
                                            {{ scanned_batches[0].customer_part_number }}<br />
                                            {{ scanned_batches[0].company }}
                                        </span>
                                    </div>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : $bp.smallScreen ? 'max-height: calc(100vh - 160px)' : 'max-height: calc(90vh - 160px)'"
                                    >
                                        <v-layout
                                            row
                                            v-for="(item, index) in scanned_batches"
                                            :key="`schedule-${index}`"
                                            class="schedule-list py-2"
                                            :class="{ 'grey lighten-3': index % 2 == 1 }"
                                        >
                                            <v-flex xs7 my-auto pl-2 pr-1>
                                                {{ item.batch_control_id }}
                                                <!-- <br/>
                                                Qty: {{ item.warehouse_qty }} -->
                                            </v-flex>
                                            <v-flex xs3 pl-0 pr-3 my-auto>
                                                <v-text-field
                                                    v-model="scanned_qty[index]"
                                                    :label="$t('lang.qty')"
                                                    hide-details
                                                    single-line
                                                    outline
                                                    readonly
                                                    class="center-label qty-full"
                                                    tabindex="-1"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1 my-auto>
                                                <v-btn icon class="mx-0" @click="props.remove(index)">
                                                    <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </vue-perfect-scrollbar>
                                </template>
                            </bc-scan-barcode>
                            <bc-btn-add @invoke-method="openPartDialog()" :tooltip="$t('lang.create_package')" perm="repack.create"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetRepacks()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="packages_headers"
                        :items="packages || []"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :pagination.sync="pagination"
                        :must-sort="true"
                        :total-items="packages.length || 0"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showRepack(props.item)">
                                <td>
                                    <v-icon v-if="props.item.printed == '0'" color="green">print</v-icon>
                                </td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.shipping_unit }}</td>
                                <td>{{ props.item.repack_qty }}</td>
                                <td>{{ props.item.shipping_weight ? `${props.item.shipping_weight} lbs` : "" }}</td>
                                <td class="text-center">
                                    <v-chip
                                        disabled
                                        round
                                        text-color="white"
                                        class="fs-14 text-center"
                                        :color="props.item.has_ship_tag == '1' ? 'green' : 'orange'"
                                    >
                                        <span style="min-width: 60px">{{ props.item.has_ship_tag == "1" ? "Pass" : "Hold" }}</span>
                                    </v-chip>
                                </td>
                                <td>{{ props.item.created_by }}</td>
                                <td>{{ props.item.date_created }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="repack"></bc-pagination>
                </v-card-text>
            </v-card>
            <bc-dialog :value="part_dialog" max-width="700">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.select_part") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="part_dialog"
                            :dialog-status="part_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-data-table :headers="parts_headers" :items="pending_parts_summary || []" hide-actions>
                            <template slot="items" slot-scope="props">
                                <tr class="clickable" @mouseup.left="createPackage(props.item.part_id)">
                                    <td>{{ props.item.company }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.customer_part_number }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="repack_dialog" max-width="700">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currRepackField("repack_id") ? $t("lang.view_package") : $t("lang.create_package") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeRepackDialog"
                            :dialog-status="repack_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="repack">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 pa-0>
                                        <v-layout row wrap inner-layout pb-3 :class="{ 'prevent-click': currRepackField('repack_id') }">
                                            <v-flex xs12 sm6 align-self-start>
                                                <span class="fs-18">{{ $t("lang.name") }}</span>
                                                <h2>{{ currRepackField("name") ? currRepackField("name") : "---" }}</h2>
                                                <span class="fs-18">{{ $t("lang.customer_part_number") }}</span>
                                                <h2>{{ currRepackField("customer_part_number") ? currRepackField("customer_part_number") : "---" }}</h2>
                                                <span class="fs-18">{{ $t("lang.company") }}</span>
                                                <h2>{{ currRepackField("company") ? currRepackField("company") : "---" }}</h2>
                                            </v-flex>
                                            <v-flex xs12 sm6 align-self-start>
                                                <span class="fs-18">{{ $t("lang.created_by") }}</span>
                                                <h2>{{ currRepackField("created_by") ? currRepackField("created_by") : "---" }}</h2>
                                                <span class="fs-18">{{ $t("lang.date_created") }}</span>
                                                <h2>{{ currRepackField("date_created") ? currRepackField("date_created") : "---" }}</h2>
                                                <span class="fs-18">{{ $t("lang.shipping_weight") }}</span>
                                                <h2>{{ currRepackField("shipping_weight") ? `${currRepackField("shipping_weight")} lbs` : "---" }}</h2>
                                            </v-flex>
                                        </v-layout>
                                        <v-data-table
                                            :headers="repack_headers"
                                            :items="
                                                currRepackField('repack_id') && currRepackField('repack_details')
                                                    ? currRepackField('repack_details')
                                                    : (scanned_batches || []).length > 0
                                                    ? scanned_batches
                                                    : []
                                            "
                                            item-key="batch_id"
                                            :no-data-text="$t('lang.no_results_matching')"
                                            hide-actions
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>{{ props.item.batch_control_id }}</td>
                                                    <td class="text-center">{{ props.item.total_processed || "---" }}</td>
                                                    <td class="text-center">{{ props.item.total_removed || "---" }}</td>
                                                    <td class="text-center" v-if="!currRepackField('repack_id')">{{ props.item.remaining_repack || "---" }}</td>
                                                    <td class="text-center" v-if="currRepackField('repack_id')">{{ props.item.qty }}</td>
                                                    <td class="text-center" v-else>
                                                        <v-text-field
                                                            v-focus="props.index == 0 ? repack_dialog : false"
                                                            v-model="scanned_qty[props.index]"
                                                            :label="`${$t('lang.qty')} *`"
                                                            single-line
                                                            hide-details
                                                            :counter="showCounter(scanned_qty[props.index], 'repack.repack_qty')"
                                                            :rules="
                                                                ifValid([
                                                                    ...evalRules(rules_repack.repack_qty.rules),
                                                                    ...$r.max_value(props.item.remaining_repack),
                                                                ])
                                                            "
                                                            type="number"
                                                        ></v-text-field>
                                                    </td>
                                                    <td v-if="!currRepackField('repack_id')">
                                                        <v-btn tabindex="-1" icon class="mx-0" @click="removeFromSelected(props.index)">
                                                            <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <td>
                                                        <bc-btn-nonconformance
                                                            v-if="props.item.qty > 0"
                                                            ref="nonconformance"
                                                            entity_object="work_orders_batch"
                                                            :entity_id="props.item.batch_id"
                                                            :max-value="props.item.qty"
                                                            :repack-detail-id="props.item.repack_detail_id"
                                                            permanent
                                                        ></bc-btn-nonconformance>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                    <v-divider></v-divider>
                                    <v-flex xs5 my-auto fs-18 :class="{ 'prevent-click': currRepackField('repack_id') }">
                                        <span class="ml-auto">{{ `${$t("lang.shipping_unit")} *` }}</span>
                                    </v-flex>
                                    <v-flex xs7 pa-0 :class="{ 'prevent-click': currRepackField('repack_id') }">
                                        <v-text-field
                                            v-if="currRepackField('repack_id')"
                                            :value="currRepackField('shipping_unit')"
                                            single-line
                                            readonly
                                        ></v-text-field>
                                        <bc-autocomplete
                                            v-else
                                            v-model="repack.shipping_unit_id"
                                            :label="$t('lang.select')"
                                            :items="shipping_unit_options"
                                            item-value="shipping_unit_id"
                                            item-text="shipping_unit"
                                            :rules="ifValid('repack.shipping_unit_id')"
                                            single-line
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs5 my-auto fs-18 :class="{ 'prevent-click': currRepackField('repack_id') }">
                                        <span class="ml-auto">{{ $t("lang.notes") }}</span>
                                    </v-flex>
                                    <v-flex xs7 pa-0 :class="{ 'prevent-click': currRepackField('repack_id') }">
                                        <v-textarea
                                            v-model="repack.notes"
                                            :label="$t('lang.none')"
                                            single-line
                                            auto-grow
                                            rows="1"
                                            :readonly="!!currRepackField('repack_id')"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 v-if="!currRepackField('repack_id') && (scanned_batches || []).length > 1">
                                        <v-switch
                                            v-model="repack.multi_repack"
                                            :label="repack.multi_repack == '1' ? $t('lang.multiple') : $t('lang.single')"
                                            true-value="1"
                                            false-value="0"
                                            class="ml-auto"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="hasPerm('repack.delete') && currRepackField('has_packing_list') == '0'"
                            color="error"
                            @mouseup.left="$refs.deleteDialog.openDialog()"
                            >{{ $t("lang.delete") }}</v-btn
                        >
                        <v-btn v-if="!currRepackField('repack_id')" color="secondary" @mouseup.left="backToScan()">
                            <v-icon class="mr-1">keyboard_return</v-icon>
                            {{ $t("lang.back") }}
                        </v-btn>
                        <v-btn
                            v-else-if="currRepackField('has_ship_tag') == '1'"
                            color="primary"
                            class="ml-2"
                            @mouseup.left="dev_mode ? showPrinter('print_ship_tag') : printLabel(currRepackField('repack_id'))"
                        >
                            {{ "Print" }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeRepackDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn v-if="!currRepackField('repack_id')" color="success" @mouseup.left="modifyRepack('post')">{{ $t("lang.save") }}</v-btn>
                        <v-btn v-if="!currRepackField('repack_id')" color="success" @mouseup.left="modifyRepack('post', null, true)">{{
                            $t("lang.save_and_print")
                        }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="deleteDialog"
                :message="$t('lang.confirmDelete')"
                :heading="$t('lang.confirm_delete_header')"
                @onConfirm="onDeleteConfirm"
            ></delete-confirmation-dialog>
            <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
            <delete-confirmation-dialog
                ref="repackConfirmDialog"
                :headline="$t('lang.confirm_partial_batch')"
                message="The repack quanity is less than the available repack quantity and there is still room in the container, are you sure you want to continue?"
                @onConfirm="confirmCreate()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            packages_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.company"), value: "company", sortable: false },
                { text: this.$t("lang.part"), value: "name", sortable: false },
                { text: this.$t("lang.unit"), value: "shipping_unit", sortable: false },
                { text: this.$t("lang.qty"), value: "repack_qty", sortable: false },
                { text: this.$t("lang.weight"), value: "shipping_weight", sortable: false },
                { text: this.$t("lang.status"), value: "has_ship_tag", align: "center", sortable: false },
                { text: this.$t("lang.repack_by"), value: "created_by", sortable: false },
                { text: this.$t("lang.date_created"), value: "date_created", sortable: false },
            ],
            parts_headers: [
                { text: this.$t("lang.company"), sortable: false, width: "33%" },
                { text: this.$t("lang.name"), sortable: false, width: "33%" },
                { text: this.$t("lang.customer_part_number"), sortable: false, width: "33%" },
            ],
            repack: {
                shipping_unit_id: "",
                notes: "",
                multi_repack: "0",
            },
            pagination: {
                sortBy: "date_created",
                descending: true,
                rowsPerPage: -1,
                page: 1,
                totalItems: 0,
            },
            scanned_batches: [],
            scanned_qty: [],
            repack_qty: [],
            customers: null,
            current_obj: null,
            selected_batches: [],
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            file_name: "",
            repack_dialog: false,
            part_dialog: false,
            print_after: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openPartDialog", perms: ["repack.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetRepacks" },
            ],
            dbGetRepacks: _.debounce(this.getRepacks, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchRepack", {
                url: "repack",
                method: "get",
                stateProperty: "packages",
                dataProperty: "repack",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.repack) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                        vm.pagination.totalItems = vm.page.total_records;
                        vm.pagination.page = vm.page.page_num;
                        vm.pagination.rowsPerPage = vm.page.page_size;
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchRepack", {
                url: "repack",
                method: "get",
                stateProperty: "packages",
                dataProperty: "repack",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.repack) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    this.pagination.totalItems = this.page.total_records;
                    this.pagination.page = this.page.page_num;
                    this.pagination.rowsPerPage = this.page.page_size;
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_repack: (state) => state.validation.rules_repack,
            page: (state) => state.repack.page,
            parts: (state) => state.parts.parts,
            current_repack: (state) => state.repack.repack,
            packages: (state) => state.repack.packages,
            pending_parts_summary: (state) => state.repack.pending_parts_summary,
            shipping_unit_options: (state) => state.settings.shipping_unit_options,
            default_filter: (state) => state.repack.repacks_filter,
            pending_batches: (state) => state.repack.pending_batches,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currRepackField() {
            return (field) => {
                return this.current_repack && field && this.current_repack[field] ? this.current_repack[field] : "";
            };
        },
        repack_headers() {
            let _headers = [
                { text: this.$t("lang.dta_control"), sortable: false },
                { text: this.$t("lang.processed_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.removed_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.available_qty"), sortable: false, align: "center" },
                { text: this.$t("lang.repack_qty"), sortable: false, align: this.currRepackField("repack_id") ? "center" : "left", width: "100" },
                { text: "", sortable: false, align: "center" },
            ];
            if (this.currRepackField("repack_id")) {
                _headers.splice(3, 1);
            } else {
                _headers.push({ text: "", sortable: false, width: 50 });
            }
            return _headers;
        },
    },
    methods: {
        ...mapActions(["fetchCustomers"]),
        confirmCreate() {
            this.$refs.repackConfirmDialog.close();
            this.modifyRepack("post", null, this.print_after, true);
        },
        removeFromSelected(index) {
            this.scanned_batches.splice(index, 1);
            this.scanned_qty.splice(index, 1);

            if (this.scanned_batches.length == 0) {
                this.repack_dialog = false;
                this.$refs.scan_barcode.openBarcode();
            }
        },
        backToScan() {
            this.repack_dialog = false;
            this.$refs.scan_barcode.openBarcode();
            this.getPending();
        },
        getPending(scan = null) {
            if (!this.$refs.scan_barcode.barcode_dialog) this.$refs.scan_barcode.barcode_dialog = true;
            if (scan) this.$store.commit("toggleModalLoader", true);
            if (this.shipping_unit_options == null) this.getShippingUnitOptions();
            if (scan) {
                this.$store
                    .dispatch("fetchRepack", {
                        url: "repack/pending_batches",
                        method: "get",
                        stateProperty: "pending_batches",
                        commit: true,
                        body: {
                            batch_id: scan.batch_id,
                        },
                    })
                    .then((data) => {
                        if (typeof data === "undefined") {
                            this.$refs.scan_barcode.resetBarcode(true);
                        } else {
                            this.$store.commit("validationOn");
                            // this.repack_dialog = true;
                            let found = this.pending_batches.find((obj) => obj.batch_id == scan.batch_id);
                            if (found) {
                                this.scanned_batches.push(found);

                                if (found.repack_shipping_unit_id) {
                                    this.repack.shipping_unit_id = found.repack_shipping_unit_id;
                                } else {
                                    this.repack.shipping_unit_id = "";
                                }

                                if (+found.receiving_qty && +found.receiving_qty <= +found.remaining_repack) {
                                    this.scanned_qty.push(found.receiving_qty);
                                } else {
                                    this.scanned_qty.push(found.remaining_repack);
                                }
                            } else {
                                this.createAlert("error", "scan_again");
                            }
                            this.$refs.scan_barcode.activateBarcode();
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            } else {
                this.scanned_qty = [];
                this.scanned_batches.forEach((batch) => {
                    if (batch && +batch.receiving_qty && +batch.receiving_qty <= +batch.remaining_repack) {
                        this.scanned_qty.push(batch.receiving_qty);
                    } else {
                        this.scanned_qty.push(batch.remaining_repack);
                    }
                });
            }
        },
        setInitialSchedule() {
            if (this.scanned_batches.length > 0) {
                let adding_repack = { ...this.scanned_batches[0] };
                adding_repack.created_by = this.currUserField("combined_name");
                adding_repack.date_created =
                    new Date().toLocaleString("fr-CA", {
                        timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    }) +
                    " " +
                    new Date().toLocaleTimeString("en-US", {
                        timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                        hour12: false,
                        hour: "numeric",
                        minute: "numeric",
                    });
                this.$store.commit("commitRepack", {
                    property: "repack",
                    with: adding_repack,
                });

                this.repack_dialog = true;
                if (!this.repack.shipping_unit_id) this.repack.shipping_unit_id = "";
                this.repack.notes = "";
                this.repack.multi_repack = "0";
                this.$refs.scan_barcode.closeBarcode(false);
                this.$nextTick(() => {
                    if (this.$refs.repack) this.$refs.repack.resetValidation();
                });
            }
        },
        setFromScan(scan) {
            // console.log(this.schedule.filter(w=>w.receiving_id == scan.receiving_id)[0])
            let found_scan = null;
            if (scan && scan.batch_id) {
                found_scan = this.pending_batches.filter((w) => w.batch_id == scan.batch_id)[0];
                if (found_scan && this.scanned_batches.filter((s) => s.batch_id == scan.batch_id).length == 0) {
                    this.scanned_batches.push(found_scan);
                } else {
                    found_scan = null;
                }

                if (found_scan && +found_scan.receiving_qty && +found_scan.receiving_qty <= +found_scan.remaining_repack) {
                    this.scanned_qty.push(found_scan.receiving_qty);
                } else if (found_scan && found_scan.remaining_repack) {
                    this.scanned_qty.push(found_scan.remaining_repack);
                }
            }
            if (!found_scan) {
                this.createAlert("error", "scan_again");
            }
            this.$refs.scan_barcode.resetBarcode();
        },
        closeRepackDialog() {
            this.repack_dialog = false;
            this.scanned_batches = [];
            this.scanned_qty = [];
            this.$store.commit("validationOff");
            setTimeout(() => {
                this.$store.commit("commitRepack", { property: "repack", with: null });
            }, 300);
        },
        openPartDialog() {
            this.part_dialog = true;
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchRepack", {
                    url: `repack/pending_parts_summary`,
                    method: "get",
                    stateProperty: "pending_parts_summary",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        openPackageDialog() {
            this.repack_dialog = true;
            this.repack_qty = Array((this.selected_batches || []).length).fill("");
        },
        getRepacks() {
            this.startLoader();
            this.$store
                .dispatch("fetchRepack", {
                    url: "repack",
                    method: "get",
                    stateProperty: "packages",
                    dataProperty: "repack",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyRepack(method = null, id = null, print = false, confirm = false) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    this.print_after = print;
                    if (method == "delete" || this.validateForm("repack")) {
                        if (this.scanned_batches && (this.scanned_batches || []).length > 0) {
                            // check if any quantity is partially filled and open confirm if true
                            let partial_batches = [];
                            partial_batches = this.scanned_batches.filter((b, i) => +this.scanned_qty[i] < +b.remaining_repack);
                            if (partial_batches.length > 0 && !confirm) {
                                this.$refs.repackConfirmDialog.openDialog();
                                return;
                            } else {
                                let repack_details = [];
                                this.scanned_batches.forEach((b, i) => {
                                    repack_details.push({
                                        batch_id: b.batch_id,
                                        qty: +this.scanned_qty[i],
                                    });
                                });
                                this.repack.part_id = this.scanned_batches[0].part_id;
                                this.repack.is_nonconformance = "0";
                                this.repack.repack_details = repack_details;
                            }
                        }
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchRepack", {
                                pk: "repack_id",
                                id: id,
                                url: `repack/${id ? id : ""}`,
                                method: method,
                                stateProperty: "packages",
                                dataProperty: "repack",
                                mutate: true,
                                body: this.repack,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    if (method != "delete" && print && data.repack && data.repack.repack_id) {
                                        this.dev_mode ? this.showPrinter("print_ship_tag", data.repack.repack_id) : this.printLabel(data.repack.repack_id);
                                    }
                                    this.closeRepackDialog();
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        createPackage(part_id = null) {
            if (part_id) {
                this.$router.push({ name: "repack_create", params: { id: part_id } });
            }
        },
        getShippingUnitOptions() {
            this.$store.dispatch("fetchSetting", {
                url: "shipping_unit_options",
                method: "get",
                stateProperty: "shipping_unit_options",
                commit: true,
            });
        },
        showRepack(item = null) {
            this.repack_dialog = true;
            if (item) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchRepack", {
                        url: `repack/${item.repack_id}`,
                        method: "get",
                        stateProperty: "repack",
                        commit: true,
                    })
                    .then((data) => {
                        this.$store.commit("toggleModalLoader", false);
                        this.assignObj(this.repack, item, this.rules_repack);
                    });
            } else {
            }

            // this.current_obj = item;
            // if(this.$refs.repack) item ? this.$refs.repack.resetValidation() : this.$refs.repack.reset();

            // if(this.shipping_unit_options == null) this.getShippingUnitOptions();
            // this.repack_qty = Array((this.selected_batches||[]).length).fill("");
            // this.$nextTick(() => {
            //     this.assignObj(this.repack, item, this.rules_repack)
            //     this.repack_dialog = true;
            // })
        },
        onDeleteConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchRepack", {
                    pk: "repack_id",
                    id: this.currRepackField("repack_id"),
                    url: "repack/" + this.currRepackField("repack_id"),
                    method: "delete",
                    stateProperty: "packages",
                    dataProperty: "repack",
                    mutate: true,
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.deleteDialog.close();
                        this.repack_dialog = false;
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 } });
        },
        getArrayData() {
            if (this.customers == null) this.getCustomers();
        },
        printLabel(id) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchRepack", {
                    url: `repack/${id}/print_ship_tag`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.ship_tags) {
                        this.$refs.print.printReport(data.ship_tags.file_name);
                        this.$store.commit("mutateRepack", {
                            property: "packages",
                            method: "patch",
                            id: id,
                            pk: "repack_id",
                            with: {
                                printed: "1",
                            },
                        });
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        showPrinter(type, id = null) {
            // this.startLoader();
            let current_id = id ? id : this.currRepackField("repack_id");
            if (current_id) {
                this.$refs.print.openDialog();

                this.$store
                    .dispatch("fetchRepack", {
                        url: `repack/${current_id}/${type}`,
                        method: "get",
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.ship_tags) {
                            this.file_name = data.ship_tags.file_name;
                            this.$store.commit("mutateRepack", {
                                property: "packages",
                                method: "patch",
                                id: current_id,
                                pk: "repack_id",
                                with: {
                                    printed: "1",
                                },
                            });
                        } else {
                            this.file_name = "";
                            this.$refs.print.close();
                            this.createAlert();
                        }
                    });
            }
        },
    },
};
</script>
